import { watch, onUnmounted } from "vue";

export function useBodyScrollLock(isOpen: any) {
    const toggleBodyScroll = (shouldDisable: boolean) => {
        if (shouldDisable) {
            document.documentElement.classList.add("disable-scroll");
            document.body.classList.add("disable-scroll");
            console.log("DISABLE")
        } else {
            document.documentElement.classList.remove("disable-scroll");
            document.body.classList.remove("disable-scroll");
        }
    };

    watch(isOpen, (newValue) => {
        toggleBodyScroll(newValue);
    });

    onUnmounted(() => {
        toggleBodyScroll(false);
    });
}